import React from "react";
import { FormDateField, FormSelectField, FormTextField } from "./FormComponents";
import { STATES_OPTIONS, GENDER_OPTIONS, CORE_PLUS_GENDER_OPTIONS } from "../../../../../constants";
import moment from "moment";

const isDataFromPMS = process.env.REACT_APP_DATA_SOURCE === "pms-api";
const genderOptions = isDataFromPMS ? GENDER_OPTIONS : CORE_PLUS_GENDER_OPTIONS;

const ClientFormComponent = ({
  client: {
    firstName,
    lastName,
    dateOfBirth,
    dvaCardNumber,
    medicareCardNumber,
    medicareCardIRN,
    addressResidential,
    addressResidential: { streetAddress, suburb, postcode, state },
    email,
    phoneNumberHome,
    phoneNumberMobile,
    ExternalId,
    gender,
  },
  handleValueChange,
}) => {
  const handleAddressResidentialChange = (label) => (value) => {
    handleValueChange("addressResidential")({
      ...addressResidential,
      [label]: value,
    });
  };
  const age = Boolean(dateOfBirth) ? `(${moment().diff(moment(dateOfBirth, "YYYY-MM-DD"), "years")} y.o)` : "";
  return (
    <>
      <p className="menu-label">CLIENT</p>
      <div className="columns">
        <FormTextField
          onValueChange={handleValueChange("firstName")}
          className="column is-one-third"
          required
          label="FirstName"
          value={firstName}
        />
        <FormTextField
          onValueChange={handleValueChange("lastName")}
          className="column is-one-third"
          required
          label="LastName"
          value={lastName}
        />
        <FormDateField
          className="column is-one-third"
          required
          label={`Date of Birth${age}`}
          placeholder="YYYY-MM-DD"
          value={dateOfBirth}
          onValueChange={handleValueChange("dateOfBirth")}
        />
      </div>
      <div className="columns">
        <FormTextField
          onValueChange={handleValueChange("dvaCardNumber")}
          className="column is-one-third"
          label="DVA Card Number"
          value={dvaCardNumber}
        />
        <FormTextField
          onValueChange={handleValueChange("medicareCardNumber")}
          className="column is-one-third"
          label="Medicare Card Number"
          value={medicareCardNumber}
        />
        <FormTextField
          onValueChange={handleValueChange("medicareCardIRN")}
          className="column is-one-third"
          label="Medicare Card IRN"
          value={medicareCardIRN}
        />
      </div>
      <div className="columns">
        <FormTextField
          onValueChange={handleValueChange("email")}
          className="column is-half"
          label="Email"
          placeholder="eg. telecare@gmail.com"
          value={email}
        />
        <FormSelectField
          onValueChange={handleValueChange("gender")}
          options={genderOptions}
          required
          className="column is-half"
          label="Gender"
          value={gender}
        />
      </div>
      <div className="columns">
        <FormTextField
          onValueChange={handleValueChange("phoneNumberHome")}
          className="column is-half"
          label="Phone Number Home"
          placeholder="eg. 04312345678"
          value={phoneNumberHome}
        />
        <FormTextField
          onValueChange={handleValueChange("phoneNumberMobile")}
          className="column is-half"
          label="Phone Number Mobile"
          placeholder="eg. 04312345678"
          value={phoneNumberMobile}
        />
      </div>
      <div className="columns">
        <FormTextField
          onValueChange={handleAddressResidentialChange("streetAddress")}
          className="column"
          label="Street Address"
          value={streetAddress}
        />
        <FormSelectField
          onValueChange={handleAddressResidentialChange("state")}
          options={STATES_OPTIONS}
          className="column"
          label="State"
          value={state}
        />
      </div>
      <div className="columns">
        <FormTextField
          onValueChange={handleAddressResidentialChange("suburb")}
          className="column is-half"
          label="Suburb"
          value={suburb}
        />
        <FormTextField
          onValueChange={handleAddressResidentialChange("postcode")}
          className="column is-half"
          label="Postcode"
          value={postcode}
        />
      </div>
      <div className="columns">
        <FormTextField
          onValueChange={handleValueChange("ExternalId")}
          className="column is-half"
          label="URN"
          placeholder="eg. 392861"
          value={ExternalId}
        />
      </div>
    </>
  );
};

export default ClientFormComponent;
